import React from 'react'
import { useParams } from 'react-router-dom'

const EventDetail = () => {
  const { id } = useParams()

  return (
    <div className="event-detail">
      <h1>Event Details - {id}</h1>
      <div className="event-info">
        <h2>Event Information</h2>
        <p>Event details will be displayed here.</p>
      </div>
      <div className="event-rosters">
        <h2>Registered Teams</h2>
        <p>No teams registered yet.</p>
      </div>
      <div className="event-actions">
        <button>Edit Event</button>
        <button>Delete Event</button>
        <button>Export Rosters</button>
      </div>
    </div>
  )
}

export default EventDetail